"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useMemo } from "react";

export default function useURL() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return useMemo(
    () =>
      new URL(
        `${pathname}?${searchParams.toString()}`,
        typeof window !== "undefined"
          ? window.location.origin
          : "https://tilliX.app",
      ),
    [pathname, searchParams],
  );
}
